/**
 * GroupsPanel — body of the Home "Groups" feed tab. The sub-tab bar itself is
 * rendered by Home inside the sticky feed header (Figma 5491-11453).
 */
import { GROUP_TABS } from '@wlb/shared/constants';
import { AllGroupsTab } from './AllGroupsTab';
import { GroupPostsTab } from './GroupPostsTab';
import { GROUPS_PANEL_ID, groupTabId, type GroupTabKey } from './GroupTabs';
import { MyGroupsTab } from './MyGroupsTab';
import './groups.css';

interface GroupsPanelProps {
  activeTab: GroupTabKey;
}

export function GroupsPanel({ activeTab }: GroupsPanelProps) {
  const renderTab = () => {
    if (activeTab === GROUP_TABS.MY_GROUPS) return <MyGroupsTab />;
    if (activeTab === GROUP_TABS.ALL_GROUPS) return <AllGroupsTab />;
    return <GroupPostsTab />;
  };

  return (
    <div
      id={GROUPS_PANEL_ID}
      role="tabpanel"
      aria-labelledby={groupTabId(activeTab)}
      tabIndex={0}
    >
      {renderTab()}
    </div>
  );
}
